export const externalRedirect = (url: string): void => {
  if (!url.startsWith("https:")) {
    throw Error(
      "If you are redirecting to an internal path please use the Redirect component from react-router-dom"
    );
  }
  window.location.href = url;
};
